import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { classNamesConfig } from '../../../Shared/features/classnames';
import { Teaser } from './teaser';
export class GridBlock extends React.Component {
    render() {
        const p = this.props;
        const blockClassNames = classNamesConfig().grid_block;
        const itemClassNames = classNamesConfig().grid_items;
        return /*#__PURE__*/ _jsx("section", {
            className: `block block--collections collections ${blockClassNames.block}`,
            children: /*#__PURE__*/ _jsxs("div", {
                className: `block__inner ${blockClassNames.inner}`,
                children: [
                    p.title && /*#__PURE__*/ _jsx("header", {
                        className: "block__header",
                        children: /*#__PURE__*/ _jsx("h2", {
                            className: "block__title title--l",
                            children: p.title
                        })
                    }),
                    /*#__PURE__*/ _jsx("ul", {
                        className: "row teasers",
                        children: p.items.map((item, index)=>/*#__PURE__*/ _jsx(Teaser, {
                                title: item.title,
                                headingLevel: "h2",
                                intro: item.intro,
                                imageUrl: item.imageUrl,
                                imageUrlFallback: item.imageUrlFallback,
                                imageUrlLarge: item.imageUrlLarge,
                                imageAlt: item.imageAlt,
                                linkUrl: item.linkUrl,
                                extraClasses: `block__item ${itemClassNames.block}`
                            }, `grid-item-${index}`))
                    })
                ]
            })
        });
    }
} /* TH: Added to styleguide! */ 
